<template>
  <div
    class="nylon-OptionGrid"
    :class="{
      'nylon-OptionGrid--compact': compact,
      'nylon-OptionGrid--preview': preview,
      'nylon-OptionGrid--embedded': embedded,
    }"
  >
    <slot />
  </div>
</template>

<script>
/**
 * Nylon — OptionGrid
 *
 * Layout wrapper for the selectable icon-button grid used across the
 * submission wizard + edit-product (Product Type, Sales Method,
 * Decoration Method, Design Placement, simple size/variant pickers).
 * Consolidates the legacy `.generic-options` / `.simple-options` /
 * `.placement-options` families — see `_NylonOptionGrid.scss`.
 *
 * The grid owns only the flex container + button chrome. The option
 * buttons go in the default slot, authored by the consumer with the
 * `.nylon-OptionGrid-option` class (so per-picker content + v-if
 * conditionals + click handlers stay at the call site):
 *
 *   <NylonOptionGrid>
 *     <button class="nylon-OptionGrid-option" :class="{ active }">
 *       <figure><NylonIcon ... /></figure>
 *       <div class="text"><span class="heading">…</span></div>
 *     </button>
 *   </NylonOptionGrid>
 *
 * Variant props (mutually combinable; map to the SCSS modifiers):
 *   compact   — simple-options: wrapped row from base, no icon, 13px heading
 *   preview   — placement: large outline icons (icon only; columns unchanged)
 *   embedded  — narrow account column: 4-up → 3-up @lg (pair with the
 *               panel's `embedded`)
 *
 * Visibility (`v-show` / `v-if`) is applied by the consumer on the
 * component itself, same as the old outer `.x-options` div.
 */
export default {
  name: "NylonOptionGrid",
  props: {
    compact: { type: Boolean, default: false },
    preview: { type: Boolean, default: false },
    embedded: { type: Boolean, default: false },
  },
};
</script>
